import { Route } from "react-router-dom";
import PageTransition from "@components/transition.page";

export function renderPublicRoutes(publicRoutes) {
  return Object.entries(publicRoutes).map(([path, Component]) => (
    <Route
      key={path}
      path={path}
      element={
        <PageTransition>
          <Component />
        </PageTransition>
      }
    />
  ));
}

export function renderPrivateRoutes(routes) {
  return Object.entries(routes).map(([path, Component]) => (
    <Route key={path} path={path} element={<Component />} />
  ));
}
